import type { HTMLAttributes, ReactNode } from "react";

import type { TCheckboxProps } from "@/ui/components/form/Checkbox";
import type { DefinedDefaults } from "@/ui/lib";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const LOGIN_TYPES = [ "loginCode", "password" ] as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TLoginType = typeof LOGIN_TYPES[number];

export type TLoginWrapperRenderProps = {
  loginType: TLoginType;
};

export type TLoginWrapperToggleProps = {
  loginCodeLabel?: ReactNode;
  passwordLabel?: ReactNode;
};

export type TLoginWrapperRememberMeProps = {
  label?: string;
  input?: NonNullable<TCheckboxProps["input"]>;
};

export type TLoginWrapperProps = {
  title?: ReactNode;
  subtitle?: ReactNode;
  children: (props: TLoginWrapperRenderProps) => ReactNode;
  defaultLoginType?: TLoginType;
  loginType?: TLoginType;
  onLoginTypeChange?: (loginType: TLoginType) => void;
  toggle?: TLoginWrapperToggleProps;
  rememberMe?: false | TLoginWrapperRememberMeProps;
} & Omit<HTMLAttributes<HTMLElement>, "children" | "title">;

type TLoginWrapperDefaultProps = DefinedDefaults<
  TLoginWrapperProps,
  "defaultLoginType"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const LOGIN_WRAPPER_DEFAULTS = {
  defaultLoginType: "loginCode",
} satisfies TLoginWrapperDefaultProps;
